import Vue from 'vue';
import QuizApp from '../vue/quiz/QuizApp';
/*=============================
=          Initialize         =
=============================*/

if(document.getElementById('results')) {
	const params = (new URL(document.location)).searchParams;
	const resultsType = params.get('finalResult') ?? 'R7';
	const patientResultsType = params.get('patientStoriesResult') ?? 'A';
	const sections = document.querySelectorAll(`#${resultsType.toUpperCase()}, #all, #testimony-${patientResultsType.toUpperCase()}`);
	sections.forEach(section => {
		section.classList.add('showSection');
	});
}

if(document.getElementById('app')) {
	var app = new Vue({
		el: '#app',
		components: { QuizApp }
	})
}